import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";
import { useUser } from "@/app/providers";

interface Notification {
  id: string;
  email: string;
  Subject: string;
  Message: string;
  Read: boolean;
  date: string;
}

interface UseGetAllNotificationsOptions {
  userId?: string;
  email?: string;
}

interface UseGetAllNotificationsReturn {
  notificationList: Notification[];
  loading: boolean;
  refetch: () => Promise<any>;
}

interface GetAllNotificationsResponse {
  getAllNotifications?: Notification[];
  comGetAllNotifications?: Notification[];
}

/**
 * Custom hook to fetch and format the Notification list.
 */
export function useGetAllNotifications(
  options?: UseGetAllNotificationsOptions,
): UseGetAllNotificationsReturn {
  const { user } = useUser();
  const effectiveEmail =
    options?.email ?? (options?.userId ? undefined : user?.email);

  const { data, loading, refetch } = useQuery<GetAllNotificationsResponse>(
    queries.getAllNotifications,
    {
      variables: {
        userId: options?.userId,
        email: effectiveEmail,
      },
      skip: !options?.userId && !effectiveEmail,
      pollInterval: 60000,
    },
  );

  return {
    notificationList:
      data?.getAllNotifications || data?.comGetAllNotifications || [],
    loading,
    refetch,
  };
}
